import React from 'react';
import styles from './ActionsInCenter.module.scss';
import { IconButton } from 'components/common';
import { icons } from 'assets';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import {
  EDITOR_TIMELINE_STORE, EDITOR_CONTEXT_MENU_STORE,
  EDITOR_GROUPS_STORE, EDITOR_INTERACTIVE_AREAS_STORE
} from 'store';
import JumpToIAButton from './JumpToIAButton';
import JumpToShotButton from './JumpToShotButton';
import { ActionsInCenterProps } from './types';

const ActionsInCenter = (props: ActionsInCenterProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      isPlaying,
      play,
      stop
    },
    [EDITOR_CONTEXT_MENU_STORE]: {
      jumpToNextShotStart,
      jumpToPreviousShotStart,
      jumpToNextInteractiveArea,
      jumpToPreviousInteractiveArea
    },
    [EDITOR_INTERACTIVE_AREAS_STORE]: {
      selectedIAsNumber
    },
    [EDITOR_GROUPS_STORE]: {
      isAnyGroupSelected
    }
  } = props;

  const onClick = () => {
    isPlaying
      ? stop()
      : play();
  };

  return (
    <div className={styles.container}>
      <JumpToShotButton
        direction='previous'
        onClick={jumpToPreviousShotStart}
        disabled={!isAnyGroupSelected}
      />
      <JumpToIAButton
        direction='previous'
        onClick={jumpToPreviousInteractiveArea}
        disabled={!isAnyGroupSelected}
      />
      <IconButton
        icon={icons.arrowJumpLeft}
        onClick={onClick}
        title='Jump To Previous Key Point'
        disabled={!selectedIAsNumber}
      />
      <IconButton
        icon={isPlaying ? icons.pause : icons.play}
        onClick={onClick}
        title={isPlaying ? 'Stop' : 'Play'}
        disabled={!isAnyGroupSelected}
      />
      <IconButton
        icon={icons.arrowJumpRight}
        onClick={onClick}
        title='Jump To Next Key Point'
        disabled={!selectedIAsNumber}
      />
      <JumpToIAButton
        direction='next'
        onClick={jumpToNextInteractiveArea}
        disabled={!isAnyGroupSelected}
      />
      <JumpToShotButton
        direction='next'
        onClick={jumpToNextShotStart}
        disabled={!isAnyGroupSelected}
      />
    </div>
  );
};

export default inject(
  EDITOR_TIMELINE_STORE, EDITOR_CONTEXT_MENU_STORE, EDITOR_GROUPS_STORE, EDITOR_INTERACTIVE_AREAS_STORE
)(observer(ActionsInCenter));
